import php from 'highlight.js/lib/languages/php';
import java from 'highlight.js/lib/languages/java';
import python from 'highlight.js/lib/languages/python';
import pythonrepl from 'highlight.js/lib/languages/python-repl';
import shell from 'highlight.js/lib/languages/shell';
import c from 'highlight.js/lib/languages/c';
import cplus from 'highlight.js/lib/languages/cpp';
import csharp from 'highlight.js/lib/languages/csharp';
import javascript from 'highlight.js/lib/languages/javascript';
import typescript from 'highlight.js/lib/languages/typescript';
import diff from 'highlight.js/lib/languages/diff';
import json from 'highlight.js/lib/languages/json';
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';
import ini from 'highlight.js/lib/languages/ini';
import bash from 'highlight.js/lib/languages/bash';
import sql from 'highlight.js/lib/languages/sql';
import properties from 'highlight.js/lib/languages/properties';
import http from 'highlight.js/lib/languages/http';
import django from 'highlight.js/lib/languages/django';
import twig from 'highlight.js/lib/languages/twig';
import go from 'highlight.js/lib/languages/go';
import plaintext from 'highlight.js/lib/languages/plaintext';

const languages = {
  php,
  java,
  python,
  'python-repl': pythonrepl,
  shell,
  c,
  cpp: cplus,
  csharp,
  javascript,
  typescript,
  diff,
  json,
  xml,
  yaml,
  ini,
  bash,
  sql,
  properties,
  http,
  django,
  twig,
  go,
  plaintext,
};

export default languages;
